module.exports = __webpack_public_path__ + "static/media/journal-accent-light.5cd11ffa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/journal-accent-light.svg
// module id = 699
// module chunks = 0